"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TypeScriptUtility_1 = require("./common/TypeScriptUtility");
var RoseTree_1 = require("./RoseTree");
/**
 * Returns a copy of the tree where any node that does not satisfy the predicate has been omitted along with all of its descendants,
 * regardless of whether or not the descendants satisfy the predicate. In other words, the remaining nodes are those whose entire ancestry
 * chain (up to the root) satisfies the predicate. The root node is always kept, whether or not it satisfies the predicate.
 *
 * @param tree - The tree to filter.
 * @param p - The predicate.
 */
function filterSubtreeRoots(tree, p) {
    var children = tree.children.filter(function (child) { return p(child.node); }).map(function (child) { return filterSubtreeRoots(child, p); });
    return new RoseTree_1.RoseTree(tree.node, children);
}
exports.filterSubtreeRoots = filterSubtreeRoots;
/**
 * Returns a copy of the tree in which subtrees have been omitted iff all the elements in the subtree (including its root) do not satisfy
 * the predicate. In other words, all the items anywhere in the tree that satisfied the predicate remain in the result, along with the nodes
 * that connect them to the root.
 *
 * @param tree - The tree to filter.
 * @param p - The predicate.
 */
function filterSubtrees(tree, p) {
    var children = TypeScriptUtility_1.removeNulls(tree.children.map(function (child) { return filterSubtrees(child, p); }));
    return p(tree.node) ? new RoseTree_1.RoseTree(tree.node, children) : null;
}
exports.filterSubtrees = filterSubtrees;
//# sourceMappingURL=RoseTreeFilters.js.map